export function newsInit() {

    $(document).ready(() => {

        // https://codepen.io/leemagbanua/pen/GEZGJB/
        // $('.page-news .post').on('mousemove', function(e) {
        //     let xAxis = (window.innerWidth / 2 - e.pageX) / 10;
        //     let yAxis = (window.innerHeight / 2 - e.pageY) / 5;
        //     $(this).css('transform', `rotateY(${xAxis}deg) rotateX(${yAxis}deg)`);
        // });

        $('.page-news a#close').on('click', function() {
            $('.page-news .subscribe').fadeOut(function() {

                if ($(window).width() >= 992) {
                    $('.page-news .header').css('padding-top', '150px');
                } else {
                    $('.page-news .header').css('padding-top', '100px');
                }

            });
        });


        // let post_url = encodeURI(window.location.href);
        let post_url = 'ritual.idea-booth.com';
        let title = $('.main h3.title').text();

        $('#share-fb').on('click', function() {
            let url_fb = `https://www.facebook.com/sharer/sharer.php?href=${post_url}&t=${title}&u=${post_url}`;
            window.open(url_fb, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        });


        $('#share-twitter').on('click', function() {
            let url_twitter = `https://twitter.com/intent/tweet?url=${post_url}&text=${title}&hashtags=RitualCannabis`;
            window.open(url_twitter, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        });

        $('#share-linkedin').on('click', function() {
            // let url_linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${post_url}`
            let url_linkedin = `https://www.linkedin.com/shareArticle?mini=true&url=${post_url}&title=${title}`
            window.open(url_linkedin, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
        });
        
    });

}